import { colors } from '../../utils/colors'

export const viewRequestsModalStyles = {
  title: { color: colors.principal },
  modalContainer: { padding: '1.5% 0' },
  tHead: {
    textTransform: 'capitalize',
    fontSize: '13px',
    fontWeight: 'bold',
    color: colors.black,
    padding: '8px 8px',
  },
  tData: { fontSize: '13px', padding: '8px 8px' },
  checkIcon: {
    color: colors.green,
    boxSize: 4,
    cursor: 'pointer',
    margin: '0px 3px',
  },
  closeIcon: {
    color: colors.red,
    boxSize: 3,
    cursor: 'pointer',
    margin: '0px 3px',
  },
  loading: {
    width: '100%',
    height: '20vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noResultsContainer: {
    width: '100%',
    height: '20vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noResults: {
    textAlign: 'center',
    padding: '20px 0px',
    fontWeight: 'bold',
  },
  tHeadMobile: {
    extTransform: 'capitalize',
    fontSize: '13px',
    fontWeight: 'bold',
    color: colors.black,
    padding: '12px',
  },
  tDataMobile: { fontSize: '13px', padding: '12px' },
  checkIconMobile: {
    color: colors.green,
    boxSize: 6,
    cursor: 'pointer',
    margin: '0px 3px 10px 3px',
  },
  closeIconMobile: {
    color: colors.red,
    boxSize: 5,
    cursor: 'pointer',
    margin: '0px 3px',
  },
}
